const init = [
  {
    lang: "en",
    dir: "ltr",
    id: ""
  },
  {
    lang: "fa",
    dir: "rtl",
    id: ""
  }
];

const culture = (state = JSON.stringify(init), action) => {
  switch (action.type) {
    case "SET_CULTURE":
      return JSON.stringify(action.data);
    default:
      return state;
  }
};

export default culture;
